import React from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import SecondBg from "Utils/Assets/Images/Vector.png";
import VisionIcon from "Utils/Assets/Icons/VisionIcon.png";
import VisionIocn1 from "Utils/Assets/Icons/VisionIocn1.png";

const OurMissionVision = () => {
    const pillars = [
        {
            index: "01",
            label: "Mission",
            icon: VisionIcon,
            description:
                "We're building a community that blends seamlessly into the phygital era, empowering users to connect, earn, and grow within a virtual environment designed to create real-world impact. By embracing blockchain technology and innovative virtual experiences, we provide a space where users can meet, collaborate, and thrive — all while taking control of their future.",
            aos: "fade-right",
        },
        {
            index: "02",
            label: "Vision",
            icon: VisionIocn1,
            description:
                "To establish a transformative global virtual community that enables seamless work, commerce, and personal development — with measurable goals of generating $50M in user economic activity and reducing geographical barriers to opportunity by 75% within three years.",
            aos: "fade-left",
        },
    ];

    const stats = [
        {
            label: "Total Value Earned",
            value: "$50M+",
            description: "In Rewards Distributed",
            aos: "fade-right",
        },
        {
            label: "Users Worldwide",
            value: "10M+",
            description: "MVR Coin Transactions",
            aos: "fade-up",
        },
        {
            label: "Growth Rate",
            value: "500K+",
            description: "Active Users",
            aos: "fade-left",
        },
    ];

    return (
        <div className={styles.root}>
            <img
                src={SecondBg}
                alt="overlay"
                className={styles.OurMissionVisionOverlay}
            />

            <MeetUsWrapper>
                <div className={styles.content}>
                    <div
                        className={styles.heading}
                        data-aos="fade-up"
                        data-aos-duration="800"
                        data-aos-once="false"
                    >
                        <span className={styles.eyebrow}>Our Purpose</span>
                        <h1 className={styles.title}>
                            Our Mission &amp;{" "}
                            <span className={styles.titleAccent}>
                                Our Vision
                            </span>
                        </h1>
                    </div>

                    <div className={styles.cards}>
                        {pillars.map((p) => (
                            <article
                                key={p.label}
                                className={styles.card}
                                data-aos={p.aos}
                                data-aos-duration="800"
                                data-aos-once="false"
                            >
                                <span className={styles.cardIndex}>
                                    {p.index}
                                </span>

                                <div className={styles.cardHeader}>
                                    <div className={styles.iconChip}>
                                        <img
                                            src={p.icon}
                                            alt={`${p.label} icon`}
                                            className={styles.icon}
                                        />
                                    </div>
                                    <h2 className={styles.cardTitle}>
                                        {p.label}
                                    </h2>
                                </div>

                                <p className={styles.cardDescription}>
                                    {p.description}
                                </p>
                            </article>
                        ))}
                    </div>

                    <div className={styles.SecondCards}>
                        {stats.map((s) => (
                            <div
                                key={s.label}
                                className={styles.SCard}
                                data-aos={s.aos}
                                data-aos-duration="800"
                                data-aos-once="false"
                            >
                                <p className={styles.ScardTitle}>{s.label}</p>
                                <p className={styles.ScardValue}>{s.value}</p>
                                <p className={styles.ScardDescription}>
                                    {s.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default OurMissionVision;
